import { toast } from 'react-toastify'
import * as Sentry from '@sentry/react'
import { AUTH_HUB_LOGOUT_URL } from 'utils/auth-config'

// return true if validate error received
export function handle(
  data: any,
  e: any,
  sentryTags = {},
  sentryExtra = {},
  preventSentryCapturing = false
) {
  if (!preventSentryCapturing) {
    Sentry.captureException(e, {
      tags: sentryTags,
      extra: {
        ...sentryExtra,
        response: e.response?.data,
        status: e.response?.status,
        url: e.config?.url,
        error: e,
      },
    })
  }

  if (e.response) {
    const response = e.response

    if (response.status === 401) {
      window.location.replace(AUTH_HUB_LOGOUT_URL)
    } else {
      let message = ''

      if (response.data) {
        if (
          response.data.message &&
          response.data.message === 'Internal server error'
        ) {
          message =
            'Internal server error, please try again later in a few minutes'
        } else if (response.data.message) {
          message = response.data.message
        } else if (response.data.error) {
          message = `Error: ${response.data.error}`
        } else if (response.data.detail) {
          message = `Error: ${response.data.detail}`
        }
      } else if (typeof e === 'string') {
        message = e
      } else {
        message = 'An error occurred, please try again later in a few minutes'
      }

      if (response.data) {
        if (response.data.statusCode >= 500) {
          toast.error(message)
          // console.error(message)
        } else if (
          response.data.statusCode !== 404 &&
          response.status !== 404
        ) {
          toast.warn(message)
          // console.warn(message)
        }
      } else {
        toast.error(message)
        // console.error(e)
      }

      return data
    }
  } else if (e.data?.message) {
    const message = e.data.message

    toast.warn(message)

    return data
  } else {
    toast.error('An error occurred, please try again later in a few minutes')

    return data
  }
}
